import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './auth/context/AuthContext';
const LandingPage = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  // const { isAuthenticated, logout } = useAuth(); // Assume you have an AuthContext
  // const isAuthenticated = false;

  const { isOwnerAuthenticated, ownerLogout } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className='min-h-screen bg-gray-100'>
      {/* Navigation */}
      <nav
        className={`fixed w-full z-10 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className='container mx-auto px-6 py-3 flex justify-between items-center'>
          <a
            className={`font-bold text-xl ${
              isScrolled ? 'text-indigo-600' : 'text-white'
            }`}
            href='/'
          >
            SMS Marketing
          </a>
          <div>
            {isOwnerAuthenticated ? (
              <>
                <Link
                  to='/owner/dashboard'
                  className='text-white hover:text-indigo-100 mx-4'
                >
                  Dashboard
                </Link>
                <button
                  onClick={ownerLogout}
                  className='text-white hover:text-indigo-100'
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link
                  to='/owner/login'
                  className='bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition duration-300'
                >
                  Sign In
                </Link>
                <Link
                  to='/owner/signup'
                  className='bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition duration-300'
                >
                  Sign Up
                </Link>
              </>
            )}
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <header className='bg-indigo-600 text-white'>
        <div className='container mx-auto px-6 py-16 text-center'>
          <h1 className='text-4xl md:text-6xl font-bold mb-2'>
            Revolutionize Your Restaurant's Communication
          </h1>
          <p className='text-xl mb-8'>
            Engage customers, boost loyalty, and increase sales with our
            powerful messaging platform.
          </p>
          <a
            href='/owner/dashboard'
            className='bg-white text-indigo-600 py-2 px-6 m-2 rounded-full text-lg font-semibold hover:bg-gray-100 transition duration-300'
          >
            Business
          </a>
          <a
            href='/subscriptions'
            className='bg-white text-indigo-600 py-2 px-6 rounded-full text-lg font-semibold hover:bg-gray-100 transition duration-300'
          >
            Customer
          </a>
        </div>
      </header>

      {/* Features Section */}
      <section className='py-12 bg-white'>
        <div className='container mx-auto px-6'>
          <h2 className='text-3xl font-semibold text-center mb-8'>
            How It Works
          </h2>
          <div className='flex flex-wrap -mx-4'>
            <div className='w-full md:w-1/3 px-4 mb-8'>
              <div className='bg-gray-100 rounded-lg p-6 h-full'>
                <h3 className='text-xl font-semibold mb-4'>
                  1. Set Up Your Account
                </h3>
                <p>
                  Create your restaurant profile and import your customer list.
                </p>
              </div>
            </div>
            <div className='w-full md:w-1/3 px-4 mb-8'>
              <div className='bg-gray-100 rounded-lg p-6 h-full'>
                <h3 className='text-xl font-semibold mb-4'>
                  2. Create Campaigns
                </h3>
                <p>
                  Design engaging messages, promotions, and loyalty programs.
                </p>
              </div>
            </div>
            <div className='w-full md:w-1/3 px-4 mb-8'>
              <div className='bg-gray-100 rounded-lg p-6 h-full'>
                <h3 className='text-xl font-semibold mb-4'>
                  3. Engage Customers
                </h3>
                <p>Send targeted messages and track engagement in real-time.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Potential Customers Section */}
      <section className='py-12 bg-gray-100'>
        <div className='container mx-auto px-6'>
          <h2 className='text-3xl font-semibold text-center mb-8'>
            Who Can Benefit?
          </h2>
          <div className='flex flex-wrap -mx-4'>
            <div className='w-full md:w-1/4 px-4 mb-8'>
              <div className='bg-white rounded-lg p-6 h-full'>
                <h3 className='text-xl font-semibold mb-4'>Fine Dining</h3>
                <p>Enhance the experience of your high-end clientele.</p>
              </div>
            </div>
            <div className='w-full md:w-1/4 px-4 mb-8'>
              <div className='bg-white rounded-lg p-6 h-full'>
                <h3 className='text-xl font-semibold mb-4'>Casual Eateries</h3>
                <p>Keep customers coming back with timely promotions.</p>
              </div>
            </div>
            <div className='w-full md:w-1/4 px-4 mb-8'>
              <div className='bg-white rounded-lg p-6 h-full'>
                <h3 className='text-xl font-semibold mb-4'>Cafes & Bakeries</h3>
                <p>Promote daily specials and build a loyal following.</p>
              </div>
            </div>
            <div className='w-full md:w-1/4 px-4 mb-8'>
              <div className='bg-white rounded-lg p-6 h-full'>
                <h3 className='text-xl font-semibold mb-4'>Food Trucks</h3>
                <p>Keep customers informed about your changing locations.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className='py-12 bg-white'>
        <div className='container mx-auto px-6'>
          <h2 className='text-3xl font-semibold text-center mb-8'>
            Membership Plans
          </h2>
          <div className='flex flex-wrap -mx-4'>
            <div className='w-full md:w-1/3 px-4 mb-8'>
              <div className='bg-gray-100 rounded-lg p-6 h-full'>
                <h3 className='text-xl font-semibold mb-4'>Basic</h3>
                <p className='text-4xl font-bold mb-4'>
                  $29<span className='text-sm font-normal'>/month</span>
                </p>
                <ul className='mb-6'>
                  <li>Up to 500 subscribers</li>
                  <li>Basic analytics</li>
                  <li>Email support</li>
                </ul>
                <a
                  href='#'
                  className='block text-center bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition duration-300'
                >
                  Choose Plan
                </a>
              </div>
            </div>
            <div className='w-full md:w-1/3 px-4 mb-8'>
              <div className='bg-gray-100 rounded-lg p-6 h-full border-2 border-indigo-600'>
                <h3 className='text-xl font-semibold mb-4'>Pro</h3>
                <p className='text-4xl font-bold mb-4'>
                  $79<span className='text-sm font-normal'>/month</span>
                </p>
                <ul className='mb-6'>
                  <li>Up to 2000 subscribers</li>
                  <li>Advanced analytics</li>
                  <li>Priority support</li>
                </ul>
                <a
                  href='#'
                  className='block text-center bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition duration-300'
                >
                  Choose Plan
                </a>
              </div>
            </div>
            <div className='w-full md:w-1/3 px-4 mb-8'>
              <div className='bg-gray-100 rounded-lg p-6 h-full'>
                <h3 className='text-xl font-semibold mb-4'>Enterprise</h3>
                <p className='text-4xl font-bold mb-4'>Custom</p>
                <ul className='mb-6'>
                  <li>Unlimited subscribers</li>
                  <li>Custom integrations</li>
                  <li>24/7 dedicated support</li>
                </ul>
                <a
                  href='#'
                  className='block text-center bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition duration-300'
                >
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className='py-12 bg-indigo-600 text-white'>
        <div className='container mx-auto px-6 text-center'>
          <h2 className='text-3xl font-semibold mb-4'>
            Ready to Transform Your Customer Engagement?
          </h2>
          <p className='mb-8'>
            Join thousands of restaurants already using RestaurantMessenger to
            boost their business.
          </p>
          <a
            href='#'
            className='bg-white text-indigo-600 py-2 px-6 rounded-full text-lg font-semibold hover:bg-gray-100 transition duration-300'
          >
            Start Your Free Trial
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className='bg-gray-800 text-white py-8'>
        <div className='container mx-auto px-6'>
          <div className='flex flex-wrap justify-between'>
            <div className='w-full md:w-1/4 mb-6 md:mb-0'>
              <h3 className='text-lg font-semibold mb-2'>
                RestaurantMessenger
              </h3>
              <p className='text-sm'>
                Empowering restaurants with powerful communication tools.
              </p>
            </div>
            <div className='w-full md:w-1/4 mb-6 md:mb-0'>
              <h3 className='text-lg font-semibold mb-2'>Quick Links</h3>
              <ul className='text-sm'>
                <li>
                  <a href='#' className='hover:text-indigo-400'>
                    About Us
                  </a>
                </li>
                <li>
                  <a href='#' className='hover:text-indigo-400'>
                    Features
                  </a>
                </li>
                <li>
                  <a href='#' className='hover:text-indigo-400'>
                    Pricing
                  </a>
                </li>
                <li>
                  <a href='#' className='hover:text-indigo-400'>
                    Contact
                  </a>
                </li>
              </ul>
            </div>
            <div className='w-full md:w-1/4 mb-6 md:mb-0'>
              <h3 className='text-lg font-semibold mb-2'>Legal</h3>
              <ul className='text-sm'>
                <li>
                  <a href='#' className='hover:text-indigo-400'>
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a href='#' className='hover:text-indigo-400'>
                    Privacy Policy
                  </a>
                </li>
              </ul>
            </div>
            <div className='w-full md:w-1/4'>
              <h3 className='text-lg font-semibold mb-2'>Connect With Us</h3>
              <div className='flex space-x-4'>
                <a href='#' className='text-white hover:text-indigo-400'>
                  <i className='fab fa-facebook-f'></i>
                </a>
                <a href='#' className='text-white hover:text-indigo-400'>
                  <i className='fab fa-twitter'></i>
                </a>
                <a href='#' className='text-white hover:text-indigo-400'>
                  <i className='fab fa-instagram'></i>
                </a>
                <a href='#' className='text-white hover:text-indigo-400'>
                  <i className='fab fa-linkedin-in'></i>
                </a>
              </div>
            </div>
          </div>
          <div className='border-t border-gray-700 mt-8 pt-8 text-sm text-center'>
            <p>&copy; 2023 RestaurantMessenger. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
